export const SENTRY_RELEASE = "local-2026-06-17T13:05:38.674Z";
export const SENTRY_DIST = "local-2026-06-17T130538.674Z";
